__turbopack_context__.v({
  "box-input": "XYJaVW_box-input",
  "box-text": "XYJaVW_box-text",
  "box-textarea": "XYJaVW_box-textarea",
  "partners-section": "XYJaVW_partners-section",
  "partners-section-form": "XYJaVW_partners-section-form",
  "partners-section-header": "XYJaVW_partners-section-header",
  "partners-section-info": "XYJaVW_partners-section-info",
  "partners-section-subtitle": "XYJaVW_partners-section-subtitle",
  "partners-section-title": "XYJaVW_partners-section-title",
  "sent-title": "XYJaVW_sent-title",
  "submit-button": "XYJaVW_submit-button",
  "submit-button-progress": "XYJaVW_submit-button-progress",
  "text-button": "XYJaVW_text-button",
});
